<!-- 残り回数表示 -->
<template>
  <div>
    <div class="label">
      <div>残り回数</div>
      <div>Remaining</div>
    </div>
    <!-- storybookの都合上、unused_frames.lengthをporpsとして受け取りたい -->
    <div class="value">{{ props.unusedFramesCount }}回</div>
  </div>
</template>

<script>
export default {
  name: "FaceUnusedNumber",
  props: {
    unusedFramesCount: {
      type: Number,
      required: false,
    },
  },
  setup(props) {
    console.log("props :>> ", props);
    return {
      props,
    };
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 11px;
  line-height: 21px;
}

.value {
  margin-top: 5px;
  font-size: 32px;
  font-weight: bold;
}
</style>
